<template>
  <div class="lg-store">
    <Hero/>
    <Winners />
<!--    <Timer/>-->
<!--    <Map/>-->
    <!--    <Footer />-->
  </div>
</template>

<script>

import Hero from "../components/hero/Hero";
import Winners from "../components/winners/Winners";
// import Timer from "../components/timer/Timer";
// import Map from "../components/map/Map";
// import Footer from "../components/footer/Footer";

export default {
  name: "Main",
  components: {
    Winners,
    // Footer,
    // Map,
    Hero
  },
  data() {
    return {}
  },
  methods: {},
  mounted() {
  }
}
</script>

<style lang="scss">
</style>
